// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"logo_logoContainer__1kN44","logo":"logo_logo__3E-3t","label":"logo_label__CD1st"};